import { containsDuplicates } from '../../ApprovalForms/NewApproval/NewApproval';

import type React from 'react';

import type { IApplicantQuestion } from '../../Components/Utilities/QuestionFieldGenerator';

export function validateForm(
  questions: IApplicantQuestion[],
  answers: Record<number, string | number | Record<string, string | boolean>>,
  setQuestionErrors: React.Dispatch<React.SetStateAction<Record<number, string>>>,
  questionsRef: React.RefObject<(HTMLDivElement | null)[]>
) {
  if (!questionsRef.current) return;
  let isValid = true;
  let questionError: number | undefined;

  questions.forEach((question: IApplicantQuestion, index: number) => {
    let tempErrorMessage = '';
    if (question.type === 'CheckBoxField') {
      const isChecked =
        answers[question.id] && Object.values(answers[question.id]).some((value) => value === true);
      if (question.required && !isChecked) {
        tempErrorMessage = 'Must select at least one option';
        if (questionError === undefined) {
          questionError = index;
        }
        isValid = false;
      }
    } else if (question.type === 'RankField') {
      const duplicates =
        answers[question.id] && containsDuplicates(Object.values(answers[question.id]));
      if (duplicates) {
        tempErrorMessage = 'Ranked choices must be unique';
        if (questionError === undefined) {
          questionError = index;
        }
        isValid = false;
      }
    } else if (question.required && !answers[question.id]) {
      tempErrorMessage =
        question.type !== 'RadioButtonField' ? 'This field is required' : 'Must select an option';
      if (questionError === undefined) {
        questionError = index;
      }
      isValid = false;
    }
    setQuestionErrors((prev) => ({
      ...prev,
      [question.id]: tempErrorMessage
    }));
  });
  if (questionError !== undefined && questionsRef.current && questionsRef.current[questionError]) {
    questionsRef.current[questionError]?.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  return isValid;
}
